import _ from 'lodash'
import {
  SAVE_PROPERTY_ANALYTICS,
  SAVE_IS_PROPERTY_REPORT_AVAILABLE,
  SAVE_REALTY_TRACK_REPORT,
} from '../constants/actionTypes'
import { fetchExternalInformationData } from '../providers/propertyAnalytics'

const MAX_COMP_SALES = 10

export const savePropertyAnalytics = propertyAnalytics => {
  return {
    type: SAVE_PROPERTY_ANALYTICS,
    propertyAnalytics,
  }
}

export const saveIsPropertyReportAvailable = isPropertyReportAvailable => {
  return {
    type: SAVE_IS_PROPERTY_REPORT_AVAILABLE,
    isPropertyReportAvailable,
  }
}

export const fetchRealtyTrackReport = listingId => async dispatch => {
  const res = await fetchExternalInformationData(listingId)

  /**
   * NOTE: It's important here that reportdata be defaulted to something so
   * optional chaining works. And the reason we need that and can't rely on
   * `_.get` is due to how that method handles null values, which is takes
   * a valid value. That's an issue because the graph will return null for
   * empty nullable types that we want to check and fallback here. Previously,
   * the endpoint would omit those values, but since the graph
   * requires clients be explicit, we now return a null value where we didn't
   * before.
   */
  const {
    reportdata = {},
    isHiddenPIR = false,
    listing_configuration = {},
  } = res || {}

  const rentalHidden = listing_configuration.is_rental_estimate_hidden

  // composite info may be at index 0, rental should always be index 1, but this should be a bit better rather than hard-coding the index
  const reportSummary = _.get(reportdata, 'summary', []).find(
    item => item.type === 'rental'
  ) || { high: null, low: null, median: null }
  const rentalRange = _.pick(reportSummary, ['low', 'high', 'estimated'])

  const propertylistArray = _.get(
    reportdata,
    'comparables.propertylistArray',
    []
  )

  const value = {
    data: reportdata,
    hidePIR: Boolean(isHiddenPIR),
    isAnalysisDataAvailable: !_.isEmpty(reportdata),
    comps: _.get(
      propertylistArray.find(({ source }) => source === 'parsed'),
      'property',
      []
    )
      .filter(property => property.type === 'sold')
      .slice(0, MAX_COMP_SALES),
    saleHistory: (reportdata.property?.historicaltransactions || []).slice(
      0,
      MAX_COMP_SALES
    ),
    taxInfo: _.get(reportdata, 'property.info', {}),
    schools: _.get(reportdata, 'neighboorhodreports.publicschools.school', []),
    neighborhood: _.get(reportdata, 'neighborhoodview.areaanalysis', {}),
    highlights: _.get(reportdata, 'neighborhoodview.communityfeatures', []),
  }

  if (rentalHidden === false) {
    value.rentals = _.get(
      propertylistArray.find(({ source }) => source === 'rental'),
      'property',
      []
    ).slice(0, MAX_COMP_SALES)

    value.rentalRange = {
      ...rentalRange,
      median: Math.floor((rentalRange.high + rentalRange.low) / 2),
    }
  }

  dispatch({
    type: SAVE_REALTY_TRACK_REPORT,
    value,
  })
}
